import { Box, Typography } from '@global-engineering-shared/gweb-material-ui';
import { useMemo } from 'react';

import LinkedFramesDetailTable from 'features/EntityDetails/components/EntityDetails/LinkedFramesDetailTable';
import useStyles from 'features/EntityDetails/components/EntityDetails/LinkedFramesDetailTable/components/LinkedFramesDetailTableContainer/LinkedFramesDetailTableContainer.styles';
import {
  getLinkedAssetFramesByStatus,
  linkedAssetFrameWithoutDiff,
} from 'features/EntityDetails/components/EntityDetails/LinkedFramesDetailTable/utils/LinkedFramesTableUtils';
import { LinkedAssetFrame } from 'types/detailsEntityType';
import { TLinkedAssetFramesTableEntity } from 'types/tableEntityType';
import { LinkedAssetFrameStatus } from 'utils/statuses';

interface ILinkedFramesDetailTableContainerProps {
  data: LinkedAssetFrame[] | null;
  previousData?: LinkedAssetFrame[] | null;
}

const LinkedFramesDetailTableContainer: React.FC<ILinkedFramesDetailTableContainerProps> = ({
  data,
  previousData,
}) => {
  const classes = useStyles();
  const currentFrames = useMemo(() => data || [], [data]);
  const previousFrames = useMemo(() => previousData || [], [previousData]);

  const linkedAssetFramesByStatus = useMemo(
    () => getLinkedAssetFramesByStatus(currentFrames, previousFrames),
    [currentFrames, previousFrames]
  );

  if (!currentFrames.length && !previousFrames.length) {
    return (
      <Typography className={classes.notFoundLabel} fontWeight={600}>
        Linked Frames Not Found
      </Typography>
    );
  }

  if (!previousData) {
    const current: TLinkedAssetFramesTableEntity[] = currentFrames.map((frame) =>
      linkedAssetFrameWithoutDiff(frame, null)
    );
    return (
      <>
        <Typography color="textSecondary" fontWeight={600}>
          Linked Frames
        </Typography>
        <LinkedFramesDetailTable data={current} />
      </>
    );
  }

  return (
    <Box className={classes.tableContainer}>
      {Object.entries(linkedAssetFramesByStatus).map(([status, frames]) =>
        frames.length > 0 ? (
          <Box key={status}>
            <Typography color="textSecondary" fontWeight={600}>
              {`${status as LinkedAssetFrameStatus} Linked Frames`}
            </Typography>
            <LinkedFramesDetailTable data={frames} />
          </Box>
        ) : null
      )}
    </Box>
  );
};

export default LinkedFramesDetailTableContainer;
